import { combineReducers } from "redux";
import productReducer from "./menu/productsSlice";
import businessReducer from "./business/businessSlice";

const rootReducer = combineReducers({
    business: businessReducer,
    products: productReducer,
});

export default rootReducer;
